/*
 * Copyright (c) 2025. Orion Analytics. All Rights Reserved
 */

import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import oa from '../../img/oa_video.mp4';

export default function VideoModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  const modalRoot = document.getElementById("modal-root");
  if (!modalRoot) return null;

  const backgroundClickCatcher = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: "transparent",
    zIndex: 100,
    pointerEvents: "none",
  };

const modalWrapperStyle = {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.85)",
    zIndex: 9999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
};

const videoContainerStyle = {
    width: "90%",
    maxWidth: "1200px",
    backgroundColor: "#000",
    borderRadius: "20px",
    overflow: "hidden",
};

const videoStyle = {
    width: "100%",
    maxHeight: "80vh",
};

const closeButtonStyle = {
    position: "absolute",
    top: "20px",
    right: "20px",
    fontSize: "28px",
    color: "white",
    cursor: "pointer",
};

  return ReactDOM.createPortal(
    <>
      {/*<div style={backgroundClickCatcher} onClick={onClose} />*/}
      <div style={backgroundClickCatcher}/>
      <div style={modalWrapperStyle} onClick={(e) => e.stopPropagation()}>
        <div style={closeButtonStyle} onClick={onClose}>
          ❌
        </div>
        <video style={videoStyle} autoPlay muted controls>
          <source src={oa} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </>,
    modalRoot
  );
}